import { dashboardApi } from "service/api";
import { LIST, panelApi, runQuery } from "./panelApi";

/**
 * Dashboard numbers of one district (RTK Query), cached per district: going
 * back to the district home shows the last numbers at once while they are
 * refreshed in the background. An error answer ({ error: true, message })
 * becomes the query's error.
 */
export const dashboardEndpoints = panelApi.injectEndpoints({
  endpoints: (build) => ({
    getDistrictDashboard: build.query({
      queryFn: (districtId) =>
        runQuery(async () => {
          const res = await dashboardApi.getDataById({
            district_ids: [districtId],
          });
          if (res?.error) throw new Error(res.message);
          return res.data;
        }),
      providesTags: (result, error, districtId) => [
        { type: LIST.dashboard, id: districtId },
      ],
    }),
  }),
});

export const { useGetDistrictDashboardQuery } = dashboardEndpoints;
